import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import Ajax from "base/Ajax";

class PasswordChangeModal extends Modal {

    buildElement() {
        if (this.built) return;
        super.buildElement();

        let $form = eotwJSXFactory('form', {class: "admin-form"}, [
            eotwJSXFactory('h1', null, ["Update Password"]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-user-current-password"}, ["Current Password"]),
                eotwJSXFactory('input', {class: "admin-form__input js-current-password", id: "admin-user-current-password", type: "password", 'data-name': "current password"}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-user-new-password"}, ["New Password"]),
                eotwJSXFactory('input', {class: "admin-form__input js-password", id: "admin-user-new-password", type: "password", 'data-name': "new password"}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-user-new-password-repeat"}, ["Repeat New Password"]),
                eotwJSXFactory('input', {class: "admin-form__input js-password-repeat", id: "admin-user-new-password-repeat", type: "password", 'data-name': "new password"}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),

            eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Update Password"]),
                eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
            ])
        ]);

        this.setContent($form);

        FormValidator.attach($form, {inputOptions: {messages: {empty: "You must enter your {name}"}}}).on('init', function () {
            let $form = this.$form;
            if ($form.find(".js-password-repeat").length > 0) {
                $form.find(".js-password-repeat").data("Validator").on("validate", function (event) {
                    if ($form.find(".js-password").val() !== $form.find(".js-password-repeat").val()) {
                        event.valid = false;
                        event.message = 'Passwords don\'t match';
                    }
                });
                $form.find(".js-password").data("Validator").on("validate", function () {
                    $form.find(".js-password-repeat").data("Validator").validate();
                });
            }
        }).on("submit", ($form) => {
            let $btn = $form.find("button[type='submit']");
            if ($btn.is(".admin-btn--loading")) return;
            $btn.addClass("admin-btn--loading");

            Ajax.post("adminUsers", "current/password", {
                currentPassword: $form.find(".js-current-password").val(),
                password: $form.find(".js-password").val(),
            }).then((data) => {
                window.User = data;
                this.hide();
                new Message("Password updated successfully", '', Message.SUCCESS);

            }).catch((e) => {
                $btn.removeClass("admin-btn--loading");
                new Message(e.message, "Couldn't update your password");
            });
        });


        this.on("click", ".js-cancel", () => {
            this.destroy();
            return false;
        });
    }
}

export default PasswordChangeModal;
